export function TwoTokensIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="14.5" cy="9.5" r="5.5" />
      <circle cx="9.5" cy="14.5" r="5.5" />
    </svg>
  );
}
